import { ProfileStatus } from 'src/app/manager-content/shared/enums/profile-status';
import { UpdateLog } from './i-update-log';

export interface IManagerProfile {
  id: number;
  name: string;
  bio: { [key: string]: string };
  lastUpdatedOn: Date;
  lastUpdatedBy: string;
  publishedOn?: Date;
  versionIds?: number[];
  status: ProfileStatus;
  updateLogs?: UpdateLog[];
}

export class ManagerProfile implements IManagerProfile {
  constructor(
    public id: number,
    public name: string,
    public bio: { [key: string]: string },
    public lastUpdatedOn: Date,
    public lastUpdatedBy: string,
    public status: ProfileStatus
  ) {}
  publishedOn?: Date;
  versionIds?: number[];
  updateLogs?: UpdateLog[];
}
